import {getAnalytics, logEvent} from 'firebase/analytics';
import {initializeApp} from 'firebase/app';
import {fetchAndActivate, getRemoteConfig, getValue,} from 'firebase/remote-config';
import {isEmpty} from "lodash";
import {OfferType} from "../models/enums/offerType";
import {Helpers} from "../utilities/helpers";

export default class FirebaseService {
  private static readonly config = {
    apiKey: `${process.env.REACT_APP_FIREBASE_API_KEY}`,
    authDomain: `${process.env.REACT_APP_FIREBASE_AUTH_DOMAIN}`,
    projectId: `${process.env.REACT_APP_FIREBASE_PROJECT_ID}`,
    storageBucket: `${process.env.REACT_APP_FIREBASE_STORAGE_BUCKET}`,
    messagingSenderId: `${process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID}`,
    appId: `${process.env.REACT_APP_FIREBASE_APP_ID}`,
    measurementId: `${process.env.REACT_APP_FIREBASE_MEASUREMENT_ID}`,
  };
  
  private static readonly app = initializeApp(FirebaseService.config);
  private static readonly remoteConfig = getRemoteConfig(FirebaseService.app);
  private static readonly analytics = getAnalytics(FirebaseService.app);
  
  constructor() {
    FirebaseService.remoteConfig.defaultConfig = {
      test_key: 'Firebase test',
    };
  }
  
  public async fetchAndActivateRemoteConfig(): Promise<void> {
    await fetchAndActivate(FirebaseService.remoteConfig);
  }
  
  public static getValue(key: string): string {
    const value = getValue(FirebaseService.remoteConfig, key).asString();
    return isEmpty(value) ? key : value;
  }
  
  public static logEvent(
    key: string,
    params?: { [key: string]: unknown }
  ): void {
    if (!Helpers.isEnvProd()) {
      console.log(`>> EVENT: ${key}`);
      return;
    }
    logEvent(FirebaseService.analytics, key, params);
  }
  
  public static getOfferClickedEventKey(type: OfferType): string {
    return `user_count_offer_${type}_clicked`;
  }
  
  public static getWrongAnswerViewEventKey(level: number): string {
    return `user_count_wrong_answer_level_${level}_offer_view`; // user_count_wrong_answer_level_1_offer_view
  }
  
  public static getTimeoutViewEventKey(level: number): string {
    return `user_count_time_out_level_${level}_offer_view`; // user_count_time_out_level_2_offer_view
  }
  
  // KEYS
  public static readonly test_key = 'test_key';
  public static readonly PAYMENT_GENERAL_ERROR_TITLE = 'PAYMENT_GENERAL_ERROR_TITLE';
  public static readonly PAYMENT_GENERAL_ERROR_DESC = 'PAYMENT_GENERAL_ERROR_DESC';
  public static readonly PAYMENT_GENERAL_ERROR_RETRY_BUTTON = 'PAYMENT_GENERAL_ERROR_RETRY_BUTTON';
  public static readonly PAYMENT_GENERAL_ERROR_HOME_BUTTON = 'PAYMENT_GENERAL_ERROR_HOME_BUTTON';
  
  // EVENTS
  public static readonly user_count_kmb_homepage_start_click = 'user_count_kmb_homepage_start_click';
  public static readonly user_count_kmb_home_play_click = 'user_count_kmb_home_play_click';
  public static readonly user_count_kmb_home_campaign_click = 'user_count_kmb_home_campaign_click';
  public static readonly user_count_p2s_click = 'user_count_p2s_click';
  public static readonly user_count_j2fs_click = 'user_count_j2fs_click';
  public static readonly user_count_kmb_payment_request = 'user_count_kmb_payment_request';
  public static readonly user_count_kmb_payment_request_back = 'user_count_kmb_payment_request_back';
  public static readonly user_count_kmb_game_limit_exceeded = 'user_count_kmb_game_limit_exceeded';
  public static readonly user_count_kmb_payment_request_success = 'user_count_kmb_payment_request_success';
  public static readonly user_count_give_up_click = 'user_count_give_up_click';
  public static readonly user_count_p2c_click = 'user_count_p2c_click';
  public static readonly user_count_j2f_click = 'user_count_j2f_click';
  public static readonly user_count_kmb_game_end_homepage_click = 'user_count_kmb_game_end_homepage_click';
}
